export default (theme) => ({
    overlay: {
        zIndex: 1250,
    },
    root: {
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: 1251,
        backgroundColor: theme.colors.transparentBlack,
    },
    content: {
        position: 'relative',
        height: 'calc(100vh - 50px)',
    },
    carousel: {
        height: '100%',
        width: '100%',
    },
});
